import React, {
  useEffect, useContext, useCallback,
} from 'react';
import { useTranslation } from 'react-i18next';

import useRouter from 'common/hooks/use-router';
import AlertsContext from 'common/contexts/alerts';
import useLocalizationModel from 'localizationModels/contexts/localization';

import PageHeader from 'common/components/PageHeader/PageHeader';
import PageLoader from 'common/components/PageLoader/PageLoader';
import LocalizationModelsForm from './LocalizationModelsForm';

const LocalizationModelsFormPage = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const { setAlert } = useContext(AlertsContext);
  const {
    save, update, fetchItem, item: localizationModel, fetchItems, items: localizationModels, isFetching,
  } = useLocalizationModel();

  const { id: localizationModelId } = router.match.params;

  useEffect(() => { fetchItem(localizationModelId); fetchItems(); }, [fetchItem, fetchItems, localizationModelId]);

  const onSubmit = useCallback(async (localizationModel) => {
    const payload = { ...localizationModel };

    if (localizationModel.id) {
      if (localizationModel.active) {
        // eslint-disable-next-line no-restricted-syntax
        for (const model of localizationModels) {
          update(model.id, { ...model, active: false });
        }
      }
      const res = await update(payload.id, payload);

      if (!res.error) {
        setAlert(t('localizationModels.successEdit'), 'success');
        router.push('/localizationmodels');
      } else {
        setAlert(res.message, 'danger');
      }
    } else {
      if (localizationModel.active) {
        // eslint-disable-next-line no-restricted-syntax
        for (const model of localizationModels) {
          update(model.id, { ...model, active: false });
        }
      }
      const res = await save(payload);

      if (!res.error) {
        setAlert(t('localizationModels.successAdd'), 'success');
        router.push('/localizationmodels');
      } else {
        setAlert(res.message, 'danger');
      }
    }
  }, [update, localizationModels, setAlert, t, router, save]);

  return (
    <>
      <PageLoader processing={isFetching} />
      <PageHeader
        title={t(`localizationModels.${localizationModel && localizationModel.id ? 'edit' : 'add'}Localization`)}
        subLink={{ url: '/localizationmodels', icon: 'arrow-left', label: t('common.back') }}
      />
      <section className="section form-page">
        <LocalizationModelsForm
          onSubmit={onSubmit}
          localizationModel={localizationModel}
          assignmentId={localizationModelId}
        />
      </section>
    </>
  );
};

export default LocalizationModelsFormPage;
